import { SortConfiguration } from './../components/generics/data-table/data-table.component';
import { Report } from './../models/report.model';
import { Tenant } from './../models/tenant.model';
import { UtilsService } from 'src/app/services/utils.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ID } from '../models/ID.model';

@Injectable({
    providedIn: 'root'
})
export class ReportsService {

    constructor(
        private http: HttpClient,
        private utilsService: UtilsService,
    ) { }

    generateReport(personas: Partial<Tenant>[]) {
        return this.http.post<Report>(`/informes`, { personas });
    }

    getReports(page: number, itemsPerPage: number, sorts: SortConfiguration[], extraParams: any) {
        const url = '/informes';
        const headers = {
            'page-number': String(page),
            'page-size': String(itemsPerPage)
        };
        const params = {
            'sort-by': this.utilsService.generateSortQueryParam(sorts)
        };
        Object.assign(params, JSON.parse(JSON.stringify(extraParams)));
        return this.http.get<Report[]>(url, { headers, observe: 'response', params });
    }

    getReportById(id: ID) {
        return this.http.get<Report>(`/informes/${id}`);
    }

    manuallyApproveReport(id: ID, razon?: string) {
        return this.http.post<Report>(`/informes/${id}/aprobacion`, { razon });
    }
}
